<template>
  <banner :rounded="true" :showImage="false">
    <div class="flex text-white gap-4 md:gap-x-14">
      <img
        src="../assets/success-green.png"
        alt="Success Badge to indicate application is complete"
        width="119"
        height="115"
        class="h-16 w-auto"
      />
      <div class="grid gap-4">
        <p class="grid items-start ">
          <span class="text-base font-semibold">{{
            $filters.formatMoney(bestApprovedAmount)
          }}</span>
          <span class="text-sm ">Please sign the loan agreement for the approved amount</span>
        </p>
        <router-link
          :to="{ name: 'Signup' }"
          class="
            btn btn--white btn--normal
            w-full
            md:h-10
            justify-self-start
            w-36
            font-semibold
          "
          >Sign</router-link
        >
      </div>
    </div>
  </banner>
</template>
<script>
import { mapGetters } from 'vuex';
import Banner from './Banner.vue';

export default {
  name: 'SignAgreementCard',
  components: {
    Banner,
  },
  computed: {
    ...mapGetters(['bestApprovedAmount']),
  },
};
</script>
